import { StartPage } from "./components/start-page";

export default StartPage;
